import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

/**
 * TakeTourButton — fixed-position floating Detective Dino with a
 * pre-baked "Take A Tour!" speech bubble.
 *
 * Final spec (May 30, 2026):
 *   - Uses the user-provided asset `/take-a-tour.png` (originally
 *     uploaded as `Detective Dino Convo Bubble.png`). The text is
 *     ALREADY drawn inside the speech bubble — no CSS overlay, no
 *     Pillow compositing. Single static asset.
 *   - Position: `fixed top-32 left-2` (upper-left corner of viewport,
 *     scrolls with the page anchored there) per the user-marked
 *     screenshot.
 *
 * Dispatches `cca:start-tour`; FirstVisitTour shows the EN/ES picker.
 */
const TakeTourButton = () => {
  const { isSpanish } = useLanguage();

  const handleStart = () => {
    window.dispatchEvent(new CustomEvent('cca:start-tour'));
  };

  return (
    <button
      type="button"
      onClick={handleStart}
      data-testid="take-tour-button"
      aria-label={isSpanish ? 'Iniciar recorrido guiado por la app' : 'Start the guided app tour'}
      className="fixed top-32 left-2 sm:left-4 z-40 w-32 sm:w-40 md:w-44 lg:w-48 focus:outline-none hover:scale-105 active:scale-95 transition-transform"
    >
      <img
        src="/take-a-tour.png"
        alt={isSpanish ? '¡Toma el recorrido!' : 'Take a tour!'}
        className="w-full h-auto drop-shadow-lg"
        data-testid="take-tour-button-image"
      />
    </button>
  );
};

export default TakeTourButton;
